<template>
  <div
    class="qrcode-container"
    ref="qrcodeContainer"
    id="qrcodeContainerID"
    @mouseenter="showPopover"
    @mouseleave="hidePopup"
  >
    <div class="qrcode-icon" :style="barCodeImg"></div>
    <div class="qr-code" id="qrCodeId"  :style="{marginRight: positionRight}">
      <div class="qr-container">
        <div class="wxAPP" :style="microImg"></div>
      </div>

      <!-- <div class="RFAPP">
        <div class="rf-img" :style="rfQrImg"></div>
        <span class="rf-description">扫码下载{{ currentDescription }}RF</span>
      </div> -->
      <!-- <img class="id_qrcode_img rms_img" title="二维码" :src="microAPPUrl" data-bm="3"> -->
    </div>
  </div>
</template>

<script>
// import QRCode from "qrcode";
const imgUrl = require('./barcode.svg');
const microAPPUrl = require('./microapp.jpg');
const imgVal = `url("data:image/svg+xml;charset=utf-8,%3Csvg width='261' height='440' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cfilter x='-86%25' y='-86%25' width='272%25' height='272%25' filterUnits='objectBoundingBox' id='b'%3E%3CfeGaussianBlur stdDeviation='45' in='SourceGraphic'/%3E%3C/filter%3E%3Cfilter x='-348.8%25' y='-348.8%25' width='797.7%25' height='797.7%25' filterUnits='objectBoundingBox' id='c'%3E%3CfeGaussianBlur stdDeviation='50' in='SourceGraphic'/%3E%3C/filter%3E%3Cfilter x='-174.4%25' y='-174.4%25' width='448.8%25' height='448.8%25' filterUnits='objectBoundingBox' id='d'%3E%3CfeGaussianBlur stdDeviation='50' in='SourceGraphic'/%3E%3C/filter%3E%3Crect id='a' x='0' y='0' width='261' height='440' rx='8'/%3E%3C/defs%3E%3Cg fill-rule='nonzero' fill='none'%3E%3Cuse fill='%23fff' xlink:href='%23a'/%3E%3Ccircle fill='%2300CE8B' opacity='.08' filter='url(%23b)' cx='36.5' cy='13.5' r='78.5'/%3E%3Ccircle fill='%2306CE00' opacity='.174' filter='url(%23c)' cx='268.5' cy='57.5' r='21.5'/%3E%3Ccircle fill='%23CEC100' opacity='.12' filter='url(%23d)' cx='217' cy='14' r='43'/%3E%3C/g%3E%3C/svg%3E")`;
export default {
    data() {
        return {
            qrcodeUrl: '',
            isPopoverVisible: false,
            barCodeImg: {},
            microImg: {},
            microAPPUrl: microAPPUrl,
            popup: false,
            showWX: false,
            rfQrImg: {},
            currentDescription: '二级节点',
            positionRight: '120px'
        };
    },
    mounted() {
    //     :style="{marginRight: positionRight}"
        this.qrcodeUrl = './images/barcode.svg';
        this.barCodeImg = { background: `url(${imgUrl}) center no-repeat` };
        this.microImg = { background: `url(${microAPPUrl})` };
        if (this.checkGuide() !== 'false') {
            this.guide();
        }
        this.eventClickOutside();
        // qrcode-container
        this.positionRight = this.getRightDistance('qrcode-container');
    },
    computed: {
    // ...mapGetters(["currentTenant", "user"]),
        isElectron() {
            return this.currentTenant.tenantCode === 'T20200421000003';
        }
    },
    methods: {
        getRightDistance(className) {
            var elements = document.getElementsByClassName(className);
            var maxRight = 0;
            for (var i = 0; i < elements.length; i++) {
                var rect = elements[i].getBoundingClientRect();
                var right = rect.right + window.scrollX;
                if (right > maxRight) {
                    maxRight = right;
                }
            }
            return `${window.innerWidth - maxRight - 68}px !important`;
        },
        eventClickOutside() {
            document.addEventListener('click', this.hidePopup);
        },
        checkGuide() {
            if (localStorage.getItem('showTips') != null) {
                if (localStorage.getItem('showTips') !== 'false') {
                    localStorage.setItem('showTips', false);
                }
                return localStorage.getItem('showTips');
            } else {
                localStorage.setItem('showTips', false);
                return true;
            }
        },
        guide() {
            const step = [
                {
                    element: '#qrcodeContainerID',
                    popover: {
                        title: '条码全链路跟踪',
                        description:
              `<div style="width:165px;height:175px;background:url(${microAPPUrl});background-size: cover;"></div>`,
                        position: 'bottom'
                    }
                }
            ];
            this.$driver.defineSteps(step);
            this.$driver.start();
            setTimeout(() => {
                const qrcodeContainer = document.getElementById('qrcodeContainerID');
                document.querySelector('#driver-popover-item').style.left = `${
                    qrcodeContainer.getBoundingClientRect().right - 200
                }px`;
                document.querySelector('.driver-popover-tip').style.right = '9px';
                document.querySelector('#driver-popover-item').style['background-image'] = imgVal;
                document.querySelector('.driver-popover-tip').style['display'] = 'none';
            });
        },
        showPopover() {
            this.showWX = true;
            if (!this.popup) {
                const qrCode = document.querySelector('#qrCodeId');
                const qrCodeContainer = document.querySelector('body');
                qrCodeContainer.appendChild(qrCode);
                qrCode.style.display = 'flex';
                this.popup = true;
            }
            if (this.popup && this.showWX) {
                document.querySelector('#qrCodeId').style.display = 'flex';
                document.querySelector('#qrCodeId').style['box-shadow'] =
          '2px 2px 12px 3px rgba(0, 0, 0, 0.2)';
                document.querySelector('#qrCodeId').style.height = '176px';
                // document.querySelector(".rf-description").style.display = "block";
                // return;
            }
        },
        hidePopup() {
            this.popup = false;
            this.showWX = false;
            document.querySelector('#qrCodeId').style.height = '0px';
            document.querySelector('#qrCodeId').style['box-shadow'] = 'none';
            // document.querySelector(".rf-description").style.display = "none";
        }
    },
    destroyed() {
        document.removeEventListener('click', this.hidePopup);
    },
    created() {
    }
};
</script>

<style scoped lang="less">
body {
  /deep/ .wrap-driver {
    left: 849.05px !important;
  }
  /deep/ .driver-popover-tip .top {
    right: 9px !important;
  }
}
.qrcode-container {
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: 20px;
  z-index: 99;
}
.icon-qrcode {
  width: 25px;
  height: 25px;
}
.qrcode-icon {
  background-position: center;
  width: 25px;
  height: 25px;
  position: relative;
  display: inline-block;
}
.wxAPP {
  display: flex;
  // width: 100%;
  width: 165px;
  // height: 92%;
  height: 100%;
  background-size: cover !important;
  background-repeat: no-repeat;
  // background-size:100%, 50% !important;
  // padding: 20px;
  box-sizing: border-box;
}
.RFAPP {
  // width: 100%;
  width: 165px;
  height: 100%;
  padding: 7px 10px 26px 10px;
  box-sizing: border-box;
  position: relative;
  .rf-img {
    width: 100%;
    height: 100%;
    background-size: cover !important;
  }
  .rf-description {
    position: absolute;
    bottom: 5px;
    left: 50%;
    font-size: 12px;
    display: none;
    transform: translateX(-50%) scale(0.85);
    width: 100%;
    text-align: center;
  }
}
</style>
<style lang="less">
#driver-popover-item {
  min-width: 165px !important;
}
.qr-code {
  position: fixed;
  // width: 330px;
  min-width: 165px;
  height: 0px;
  display: flex;
  transform: translateX(-50%);
  border-radius: 6px;
  background: white;
  top: 56px;
  right: -68px;
  z-index: 999;
  transition: all 0.4s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding: 6px 10px 10px 10px;
}
.qr-container{
  width:100%;
  height: 100%;
  box-sizing: border-box;
  padding-bottom:13px;
}
</style>
